<template>
  <nav class="navbar navbar-expand-lg navbar-dark navbar-bg justify-content-start">
    <router-link :to="{ name: 'home' }" class="btn btn-success navbar-btn-home mr-2">
      <fa-icon icon="home"/>
    </router-link>
    <a class="navbar-brand text-uppercase" href="#">{{ appName }}</a>
    <small class="version">{{ appVersion }}</small>
  </nav>
</template>

<script>

export default {
  components: {
  },

  computed: {
    appName () {
      return process.env.APP_NAME
    },

    appVersion () {
      return process.env.APP_VERSION
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~sass-material-colors/sass/sass-material-colors";

  .navbar-btn-menu {
    color: white !important;
  }

  .navbar-btn-home {
    color: white !important;
  }

  .navbar-bg {
    background-color: material-color('grey', '800');
  }

  .version {
    color: material-color('grey', '500');
    font-size: small;
  }

  .logout-link {
    color: material-color('deep-orange', '400') !important;
    font-size: small;
  }

  .logout-link:hover {
    color: material-color('deep-orange', '500') !important;
  }

  .account-link {
    color: material-color('grey', '50') !important;
    background-color: material-color('grey', '700');
    font-size: small;
  }

  .account-link:hover {
    background-color: material-color('grey', '600');
  }

  .user-link {
    color: white !important;
    background-color: material-color('orange', '900');
    font-size: small;
  }

  .user-link:hover {
    background-color: material-color('orange', '800');
  }

  /*
  .user-link a:visited, .user-link a:hover, .user-link a:active {
    color: green !important;
    background-color: material-color('blue', '700');
    font-size: small;
  }
  */
</style>



// WEBPACK FOOTER //
// src/views/navigation/GuestNavBar.vue